module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('static.news.edit.title')))]), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }]
  }, [_c('br'), _c('br')]) : _c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.news",
      "hasLabel": true
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('button.save')) + "\n  ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.sending
    },
    on: {
      "click": _vm.test
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('button.sendTest')) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1192bb58","hasScoped":false}!./src/app/pages/withNavigation/news/edit/edit.html
// module id = 2916
// module chunks = 1